//
// Imports
//

import * as BrowserUtilities from "@donutteam/browser-utilities";

//
// Component
//

export function initialiseUserGrid(userGrid: HTMLElement)
{
	const cells = userGrid.querySelectorAll<HTMLElement>(".component-user-grid-cell");

	const clickableCells = BrowserUtilities.ElementClientLib.getBooleanDataOrThrow(userGrid, "clickableCells");

	for (const cell of cells)
	{
		const href = BrowserUtilities.ElementClientLib.getStringDataOrThrow(cell, "href");

		if (clickableCells)
		{
			cell.addEventListener("click", 
				() =>
				{
					window.location.href = href;
				});
		}
	}

	userGrid.classList.add("initialised");
}

export function initialiseUserGrids()
{
	const userGrids = document.querySelectorAll(".component-user-grid:not(.initialised)") as NodeListOf<HTMLDivElement>;

	console.log("[UserGrid] Initialising " + userGrids.length + " instances...");

	for (const userGrid of userGrids)
	{
		try
		{
			initialiseUserGrid(userGrid);
		}
		catch (error)
		{
			console.error("[UserGrid] Error initialising:", userGrid, error);
		}
	}
}